<div class="action-status">
  <card-wrapper class="card-wrapper--clear">
    <div [class]="'action-status__img action-status__img--' + (icon ? icon : status)"
         [attr.data-qa]="'verification.image-' + status"></div>
    <div class="action-status__message">
      <h2 class="action-status__title" *ngIf="translatedTitle; else titleToTranslate" [innerHTML]="translatedTitle"
          [attr.data-qa]="'verification.title-' + status"></h2>

      <ng-template #titleToTranslate>
        <h2 class="action-status__title" [innerHTML]="titleText | translate"
            [attr.data-qa]="'verification.title-' + status"></h2>
      </ng-template>

      <p *ngIf="translatedDescription || description" class="action-status__description"
        [innerHTML]="translatedDescription ? translatedDescription : description | translate"></p>


    </div>
    <ng-container *ngIf="buttonTemplate; else defaultButton">
      <ng-container *ngTemplateOutlet="buttonTemplate; context: buttonTplContext"></ng-container>
    </ng-container>
    <ng-template #defaultButton>
      <div class="actions-wrapper actions-wrapper--center">
        <btn *ngIf="buttonVisible" (action)="back()" buttonText="profile-common.label.go-to-profile" data-qa="profile-common.go-to-profile.button"></btn>
      </div>
    </ng-template>
  </card-wrapper>
</div>
